// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a81b6194","703":"0d39f455","787":"d345b5f9"}[chunkId] + ".chunk.js";
};